import Cookies from 'js-cookie';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { CheckPardakhtBeforSave } from '../adapaters/CheckPardakhtBeforSave';
import { SaveAppointment } from '../adapaters/SaveAppointment';

export const handleSaveNearestTurn = (
  doctorList,
  navigate,
  confirmMsg,
  isWallet,
  nearestTurn,
  selectedDay,
  selectedTime,
  doctorInfo,
  steps,
  isNearest
) => {
  console.log('doctorList--->', doctorList);

  const idPatient = JSON.parse(
    Cookies.get('user')
  )?.IdPatient;
  const user =
    Cookies.get('user') && JSON.parse(Cookies.get('user'));
  const idNobat = Number(
    isNearest
      ? nearestTurn?.nobatInfo?.Id
      : selectedTime?.Id
  );

  const turnHasInfo =
    steps !== 7 &&
    nearestTurn?.dayInfo?.daryafteNobateBaHazine &&
    nearestTurn?.dayInfo?.hazineDaryafteNobat;

  const dayHasInfo =
    selectedDay?.daryafteNobateBaHazine &&
    selectedDay?.hazineDaryafteNobat;

  if (turnHasInfo) {
    CheckPardakhtBeforSave({
      idPatient,
      idNobat,
      doctorList,
      user,
      navigate,
      isWallet,
      doctorInfo,
    });
    return;
  }

  SaveAppointment(
    {
      idPatient,
      idNobat,
    },
    navigate
  );
};
